// @ts-nocheck
/* eslint-disable */

import React from 'react';
import EntityTable from 'app/components/CRUD/EntityTable';
import StyleIcon from '@mui/icons-material/Style';
import moment from 'moment';

const DocumentTypesTable: React.FC = () => {
  const currentLanguageCode = localStorage.getItem("EASY_MOBILITY_LANGUAGE") || 'en-us';

  return (
    <EntityTable
      // ============ PAGE CONFIGURATION ============
      pageTitle="DocumentTypes"
      pageIcon={StyleIcon}
      addButtonLabel="AddNewDocumentType"
      
      // ============ NAVIGATION URLs ============
      addPageUrl="/fare-products/document-types/new"
      viewPageUrl="/fare-products/document-types/:id"
      editPageUrl="/fare-products/document-types/:id/edit?came_from=all"
      
      // ============ API CONFIGURATION ============
      getApiUrl={`${process.env.REACT_APP_ABT_ALL_APIS_BASE_URL}/api/v1/web_portal/fare_media_policy_capping/document_types`}
      getApiMethod="GET"
      
      deleteApiUrl={`${process.env.REACT_APP_ABT_ALL_APIS_BASE_URL}/api/v1/web_portal/fare_media_policy_capping/document_types/:id`}
      deleteApiMethod="DELETE"
      
      // ============ RESPONSE CONFIGURATION ============
      responseDataPath="data.data.documentTypes"
      responsePaginationPath="data.data.pagination"
      
      // ============ TABLE CONFIGURATION ============
      idField="document_types_id"
      columns={[
        {
          field: 'code',
          headerKey: 'Code',
          align: 'center',
          sortable: true,
          sortField: 'code',
        },
        {
          field: 'en_name',
          headerKey: 'NameEnglish',
          align: 'center',
          sortable: true,
          sortField: 'en_name',
        },
        {
          field: 'ar_name',
          headerKey: 'NameArabic',
          align: 'center',
          sortable: true,
          sortField: 'ar_name',
        },
        {
          field: 'created_at',
          headerKey: 'CreatedAt',
          align: 'center',
          render: (value) => value ? moment(value).format('DD/MM/YYYY HH:mm:ss') : '-',
          sortable: true,
          sortField: 'created_at',
        },
      ]}
      
      // ============ SEARCH CONFIGURATION ============
      searchQueryParam="search"
      searchPlaceholder="SearchDocumentTypePlaceholder"
      searchInputWidth="250px"
      
      // ============ FILTER CONFIGURATION ============
      filterFields={[]}
      
      // ============ PERMISSIONS ============
      subsystemName="DocumentTypes" // Assumption for roles system
      permissionSystem="fares"
      
      // ============ ACTIONS ============
      showAddButton={true}
      showActions={true}
      showEdit={true}
      showDelete={true}
      deleteConfirmationMessage="AreYouSureDeleteDocumentType"
    />
  );
};

export default DocumentTypesTable;
